// extracted by mini-css-extract-plugin
module.exports = {"table":"TableComponent_table__MqFB_"};